// extracted by mini-css-extract-plugin
export default {"cls1":"LanguageSwitcherModal-cls1___74be23f290ca6ba0570","cls2":"LanguageSwitcherModal-cls2___d6b64f94f11d50d14f7 LanguageSwitcherModal-cls1___74be23f290ca6ba0570"};